<template>
  <div class="selection-bar" :class="{warn: !homogeneous || overLimit}">
    <span class="selection-text">
      <strong>{{ items.length }}</strong>
      {{ items.length === 1 ? 'guia selecionada' : 'guias selecionadas' }}
      <span class="sep">·</span>
      <b>{{ total | currency }}</b>
      <template v-if="homogeneous">
        <span class="sep">·</span>
        <span class="homog">{{ planName }} · {{ typeName }} · </span>
        <span :class="overLimit ? 'over' : 'homog'">
          {{ items.length }} de {{ limit }} por lote
        </span>
      </template>
      <template v-else>
        <span class="sep">·</span>
        <span class="homog">Selecione guias do mesmo convênio e tipo para montar um lote</span>
      </template>
    </span>
    <span class="selection-actions">
      <button class="btn btn-sm btn-link" @click="$emit('clear')">
        Limpar seleção <kbd>Esc</kbd>
      </button>
      <button class="btn btn-sm btn-gray btn-icon btn-icon-left"
              :class="{loading: printing}" :disabled="printing" @click="$emit('print')">
        <fa-icon :icon="['fal', 'print']"/>Imprimir
      </button>
      <button class="btn btn-sm btn-gray btn-icon btn-icon-left tooltip tooltip-left"
              :data-tooltip="repriceTooltip" :class="{loading: repricing}"
              :disabled="!canReprice || repricing" @click="$emit('reprice')">
        <fa-icon :icon="['fal', 'sync']"/>Atualizar preços
      </button>
      <button class="btn btn-sm btn-primary btn-icon btn-icon-left tooltip tooltip-left"
              :data-tooltip="batchTooltip"
              :disabled="!canBatch || !homogeneous || overLimit" @click="$emit('batch')">
        <fa-icon :icon="['fal', 'layer-group']"/>Adicionar ao lote
      </button>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 100,
    },
    planName: {
      type: String,
      default: '',
    },
    typeName: {
      type: String,
      default: '',
    },
    homogeneous: {
      type: Boolean,
      default: true,
    },
    canBatch: {
      type: Boolean,
      default: true,
    },
    printing: {
      type: Boolean,
      default: false,
    },
    canReprice: {
      type: Boolean,
      default: false,
    },
    repricing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    total() {
      return this.items.reduce((sum, item) => sum + (Number(item.totals.insurance) || 0), 0);
    },
    overLimit() {
      return this.items.length > this.limit;
    },
    repriceTooltip() {
      if (!this.canReprice) return 'Sem permissão para atualizar guias';
      return 'Atualizar preços e repasse com a regra vigente';
    },
    batchTooltip() {
      if (!this.canBatch) return 'Sem permissão para montar lotes';
      if (!this.homogeneous) return 'Mesmo convênio e tipo';
      if (this.overLimit) return `Limite de ${this.limit} guias por lote deste convênio`;
      return 'Montar lote com as guias selecionadas';
    },
  },
};
</script>
